<template>  
  <div class="offlinePayListPage">
    <mu-appbar>
        <div class="title-text" @click="open('top')">
          <p>{{pageTitle}} <i :class="titleIcon"></i></p>    
          <mu-popup position="top" popupClass="offlinePayListPage-popup" :open="topPopup" @close="close('top')">
            <mu-content-block>
              <div class="popuptitle delivery-type-order">
                <div class="title">
                  <div class="text">所有订单</div>
                  <hr class="line">
                </div>
                <div class="button-list">      
                  <mu-flat-button v-on:click="$router.push('/usercenter/allorderlist')" label="全部订单" :class="searchInfo.twoOrderType==0 && searchInfo.deliveryType==0?'demo-flat-button select':'demo-flat-button'"/>               
                  <mu-flat-button v-on:click="$router.push('/usercenter/orderList?typeValue=1&typeId=deliveryType')" label="物流订单" class="demo-flat-button"/>
                  <mu-flat-button v-on:click="$router.push('/usercenter/orderList?typeValue=2&typeId=deliveryType')" label="自提订单" class="demo-flat-button"/>
                  <mu-flat-button v-on:click="$router.push('/usercenter/orderList?typeValue=3&typeId=twoOrderType')" label="秒杀订单" class="demo-flat-button"/>
                  <mu-flat-button v-if="isIntegral" v-on:click="$router.push('/usercenter/integralOrderList')" :label="pointInfo.PointName + '订单'" style="text-transform:none" class="demo-flat-button"/>
                  <mu-flat-button v-on:click="$router.push('/usercenter/candyOrderList')" :label="'BAW订单'" class="demo-flat-button"/>
                  <!--
                  <mu-flat-button v-on:click="$router.push('/usercenter/jktOrderList')" :label="jktCname + '订单'" class="demo-flat-button"/>
                  -->
                  <mu-flat-button v-on:click="$router.push('/shangquan/offlinePayList')" label="线下买单" class="demo-flat-button select"/>
                  <!-- <mu-flat-button v-on:click="$router.push('/usercenter/orderList')" label="零售订单" class="demo-flat-button"/> -->
                </div>
              </div>              
            </mu-content-block>
          </mu-popup>
        </div>
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
        <!-- <mu-icon-button to="/shangquan/offlinePaySearch" icon=":fa fa-xisearch" slot="right"/> -->
        <mu-icon-button v-on:click="RightButonClick()" icon=":fa fa-more" slot="right"/>
        <XR-drawer right :open="rightDrawer" :docked="docked" width="70%" @close="closeDrawer()">
          <div class="right-condition">
            <div class="condition-item">
              <div class="title">下单时间</div>
              <div class="condition-content create-time">
                <div :class="searchInfo.searchTimeType==0?'value select':'value'" @click="searchTimeSelect(0)">全部</div>
                <div :class="searchInfo.searchTimeType==1?'value select':'value'" @click="searchTimeSelect(1)">一个月内</div>
                <div :class="searchInfo.searchTimeType==2?'value select':'value'" @click="searchTimeSelect(2)">一个月至三个月</div>
                <div :class="searchInfo.searchTimeType==3?'value select':'value'" @click="searchTimeSelect(3)">三个月至六个月</div>
                <div :class="searchInfo.searchTimeType==4?'value select':'value'" @click="searchTimeSelect(4)">六个月至一年</div>
                <div :class="searchInfo.searchTimeType==5?'value select':'value'" @click="searchTimeSelect(5)">一年以上</div>
              </div>
            </div>
          </div>
          <div class="condition-button">
            <div class="cbutton condition-reset" @click="searchTimeSearch(0)">重置</div>
            <div class="cbutton condition-yes" @click="searchTimeSearch(searchInfo.searchTimeType)">确定</div>
          </div>
        </XR-drawer>
    </mu-appbar>
    <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll">

      <div class="state-bar">
        <div :class="searchInfo.State==0?'state-item select':'state-item'" @click="searchTypeSearch(0)">全部</div>
        <div :class="searchInfo.State==1?'state-item select':'state-item'" @click="searchTypeSearch(1)">待支付</div>
        <div :class="searchInfo.State==2?'state-item select':'state-item'" @click="searchTypeSearch(2)">已完成</div>
      </div>
    
      <div class="order-list" v-if="!loaded">
        <div class="order-item" v-for="orderEntity in orderList" :key="orderEntity.OrderNo">
          <div class="shoptip">
            <img  class="shop-logo" :src="orderEntity.Logo ? orderEntity.Logo : siteConfig.Icon" />
            <p class="shop-name">{{orderEntity.ShopName}}</p>
            <p class="state">{{orderEntity.StateName}}</p>
          </div>
          <div class="hidden-scorll">
            <router-link :to="'/usercenter/orderdetail?orderNo='+orderEntity.OrderNo">
              <div class="suborder-item-list">
              </div>
            </router-link>
          </div>
          <div class="order-total">
            <template v-if="!orderEntity.PayLog">              
              <p class="total-text">
                订单金额：<span><i class="fa fa-rmb"></i>{{orderEntity.PayMoney.toFixed(2)}}</span>
              </p>
            </template>
            <template v-if="orderEntity.PayLog">             
              <template v-if="orderEntity.PayLog.PayType==4">                 
                <p class="total-text">
                  {{candyCname}}支付：<span>{{orderEntity.PayLog.PayMoney.toFixed(candyDecimal)}}{{candyCname}}</span>
                </p>
              </template>
              <template v-if="orderEntity.PayLog.PayType!=4">      
                <p class="total-text">
                  实付款：<span><i class="fa fa-rmb"></i>{{orderEntity.PayLog.PayMoney.toFixed(2)}}</span>
                </p>
              </template>
            </template>
          </div>
          <div class="order-operator">
            <div class="button-list">            
              <mu-raised-button label="评价" :to="'/shangquan/offlinePayEvaluate?logNo='+orderEntity.LogNo" class="orderBtn receive" v-if="orderEntity.State == 2 && orderEntity.IsComment==0"></mu-raised-button>
              <router-link :to="'/shangquan/pay?logNo='+orderEntity.LogNo" v-if="orderEntity.State == 1">
                <mu-raised-button label="付款" class="orderBtn gobuy"></mu-raised-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </v-scroll>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
import config from '../../util/siteconfigCache'
import pointconfig from '../../util/pointconfigCache'
export default {
  name : 'XR-order-head',
  data () {
    return {
	  pointInfo: pointconfig.getPointconfig(),
      titleIcon : 'fa fa-angle-down',
      topPopup: false,
      rightDrawer: false,
      docked:false,
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-90),
      loaded:true,
      orderList:[],
      siteConfig: config.getSiteconfig(),
      pageEnd : 0, // 结束页数
      searchInfo:{
        pageIndex : 0, // 开始页数
        logNo : this.$route.query.logNo,
        State: 0,
        searchTimeType: 0
      },
      scrollDone:function(){},
      pageTitle:'线下买单',
      jktCname:'JKT'
    }
  },
  mounted(){
    this.getPointInfo()
    this.getCacheSearch()
    this.getOrderList(true)
  },
  methods: {
    getPointInfo: function() {
      const ths = this;
      this.$post("/Shop/IntegralServer/GetPointSetParam")
      .then(function(res) {
        if (res.IsSuccess) {
		  ths.pointInfo = res.Data;
          pointconfig.addPointconfig(res.Data)
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    RightButonClick: function(){
      this.topPopup = false
      this.rightDrawer = true
    },    
    open (position) {
      this[position + 'Popup'] = true
      this.titleIcon = "fa fa-angle-up";
    },
    close (position) {
      this[position + 'Popup'] = false
      this.titleIcon = "fa fa-angle-down";
    },
    closeDrawer () {
      this.rightDrawer = false
      this.titleIcon = "fa fa-angle-down";
    },
    GoHistory(){
      this.$router.goBack()
    },
    getOrderList(isNewSearch){  
      this.$refs.XRtoast.load() 

      if(isNewSearch){        
        this.searchInfo.pageIndex=1
      }
      else{        
        this.searchInfo.pageIndex++
      }

      var ths = this;   
      ths.$post(
        "/Shop/StoreServer/GetShopsPhysicalOfflinePayPage",
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        ths.scrollDone()
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){          
          if(isNewSearch){
            ths.orderList = []    
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{            
            ths.$refs.XRtoast.failed(res.Msg, true)    
          }  
        }else{    

          if(isNewSearch){
            ths.orderList =res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.orderList.push(res.Data.List[i])
            }
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num

          if(ths.orderList.length<=0){            
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{            
            ths.$refs.XRPageTip.initTip()
          }

          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    addCacheSearch(){      
      window.localStorage.OfflinePayOrderSearchCache = JSON.stringify(this.searchInfo)
    },
    getCacheSearch(){
      var cacheJson = window.localStorage.OfflinePayOrderSearchCache
      if(cacheJson){
        this.searchInfo = JSON.parse(cacheJson)
        this.searchInfo.logNo = this.$route.query.logNo
      }
    },
    searchOrderType(type, searchType){
      this.close('top')
      this.loaded =true

      if(searchType == 'twoOrderType'){
        this.searchInfo.twoOrderType = type
        this.searchInfo.deliveryType = 0
      }else{
        this.searchInfo.twoOrderType = 0
        this.searchInfo.deliveryType = type
      }

      if(type ==3){
        this.pageTitle='秒杀订单'
      }
      else if(type ==1){
        this.pageTitle='物流订单'
      }
      else if(type ==2){
        this.pageTitle='自提订单'
      }
      else{
        this.pageTitle = '我的订单'
      }

      this.addCacheSearch()

      this.getOrderList(true)
    },
    searchTypeSearch(type){
      this.loaded =true
      this.searchInfo.State = type

      this.addCacheSearch()

      this.getOrderList(true)
    },
    searchTimeSelect(timeType){
      this.searchInfo.searchTimeType = timeType

      this.addCacheSearch()
    },
    searchTimeSearch(timeType){
      this.loaded =true
      this.searchInfo.searchTimeType = timeType
      
      this.addCacheSearch()

      this.closeDrawer()
      this.getOrderList(true)
    },   
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        //this.$refs.XRtoast.failed("已经到最后一页", true)\
        this.$refs.scroll.infiniteDone()
        return
      }
      this.getOrderList(false);     
    }
  }
}
</script>

<style>
.offlinePayListPage .xr-pageTip{
  top:104px;
}
.offlinePayListPage .child-view{
  background: #eee;
}
.offlinePayListPage .mu-appbar{
  position: relative;
  height: 46px;
  text-align: center;
  z-index: 20180101;
}
.offlinePayListPage .mu-appbar-title {
  font-size: 16px;
}
.offlinePayListPage .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.offlinePayListPage .title .title-text {
  margin: 0;
  padding:0;
  line-height: 48px;
}
.offlinePayListPage-popup {
  width: 100%;
  top:46px;
  height: 260px;
  z-index: 1;
  padding: 20px 0;
}
.offlinePayListPage-popup .popuptitle .title{
  overflow: hidden;
}
.offlinePayListPage-popup .popuptitle .title .text{
  float: left; 
  width:20%;
  text-align: center;
  line-height: 24px;
  color:#ccc;
}
.offlinePayListPage-popup .popuptitle .title .line{
  float: left; 
  height: 1px;
  background:#eee;
  width: 80%;
  border: none;
  margin-top: 10px;
}
.offlinePayListPage-popup .button-list{
  padding: 20px 0;
}
.offlinePayListPage-popup .button-list .demo-flat-button.select {
  color:red;
}


.offlinePayListPage .state-bar{
  overflow: hidden;
  background: white;
}
.offlinePayListPage .state-bar .state-item{
  float: left;
  width: 33.33%;
  line-height: 48px;
  text-align: center;
  font-size: 12px;
}
.offlinePayListPage .state-bar .state-item.select{
  color:red;
}

.offlinePayListPage .right-condition{
  overflow: hidden;
}
.offlinePayListPage .right-condition .condition-item{
  overflow: hidden;
}
.offlinePayListPage .right-condition .condition-item .title{
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  padding: 20px 10px 0 20px;
}
.offlinePayListPage .right-condition .condition-item .condition-content{
  overflow: hidden;
  padding: 10px;
}
.offlinePayListPage .right-condition .condition-item  .condition-content .value{
  float: left;
  width: 45.9%;
  font-size: 12px;
  border: 1px solid #eee;
  margin: 2%;
  line-height: 24px;
  border-radius: 4px;
  background: #eee;
}
.offlinePayListPage .right-condition .condition-item  .condition-content .value.select{
  float: left;
  width: 45.9%;
  font-size: 12px;
  border: 1px solid red;
  margin: 2%;
  line-height: 24px;
  border-radius: 4px;
  background: white;
}
.offlinePayListPage .condition-button{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 46px;
  line-height: 46px;
}
.offlinePayListPage .condition-button .cbutton{
  float: left;
  width: 50%;
  border-top:1px solid #eee;
}
.offlinePayListPage .condition-button .condition-yes{
  background: red;
  border-top:1px solid #eee;
  color:white;
}


.offlinePayListPage .order-list{
  overflow: hidden;
}
.offlinePayListPage .order-item{
  background: white;
  margin: 10px 0;
}
.offlinePayListPage .shoptip{
  overflow: hidden;
  background: white;
  padding:0 10px;
}
.offlinePayListPage .shoptip .shop-logo{
  float: left;
  line-height: 48px;
  height: 24px;
  margin: 12px 12px 12px 0;
}
.offlinePayListPage .shoptip .shop-name{
  float: left;
  line-height: 48px;
}
.offlinePayListPage .shoptip .state{
  float: right;
  line-height: 48px;
  color:Red;
}

.offlinePayListPage .hidden-scorll{
  overflow: hidden;
}
.offlinePayListPage .suborder-item-list{
  background: #F8F8F8;
  overflow-x:scroll;
  overflow-y: hidden;

}
.offlinePayListPage .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 15px 0;
}
.offlinePayListPage .suborder-item.more{
  width:710px;
}
.offlinePayListPage .suborder-item .order-img{
  width: 60px;
  float: left;
  border: 1px solid #eee;
  padding: 1px;
  background: white;
  margin-left: 10px;
}
.offlinePayListPage .suborder-item .product-name{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
  overflow: hidden;
  height: 60px;
  line-height: 20px;
  color:#333;
}

.offlinePayListPage .order-total{
  overflow: hidden;
  border-bottom:1px solid #eee;
  padding:0 10px;
}
.offlinePayListPage .total-text{
  float: right;  
  font-size: 12px;
  line-height: 48px;
}
.offlinePayListPage .total-text span{
  font-size: 14px;
}

.offlinePayListPage .order-operator{
  overflow: hidden;
}
.offlinePayListPage .order-operator .button-list{
  float: right;
}
.offlinePayListPage .order-operator .button-list .orderBtn{
  margin: 10px 5px 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/shangquan/offlinePayList.vue